import { Drawer } from '@minetrace/ui'
import { Box, Flex, Text, VStack, HStack } from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'
import { useT } from '../../../i18n'
import type { MiningRightMapItemResponse } from '../../../api/models/response/miningRight'
import { getComponentMeta } from './ComponentIcon'

interface Props {
  dm: MiningRightMapItemResponse | null
  onClose: () => void
}

export function DmDetailDrawer({ dm, onClose }: Props) {
  const { t } = useT()
  const open = dm != null

  return (
    <Drawer.Root open={open} onOpenChange={(e) => { if (!e.open) onClose() }} placement="end" size="md">
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content>
          <Flex alignItems="center" justifyContent="space-between" px={6} py={4} borderBottom="1px solid" borderColor="gray.200">
            <Text fontSize="lg" fontWeight="700">{dm?.name ?? ''}</Text>
            <Box as="button" type="button" onClick={onClose} p={1} borderRadius="sm" _hover={{ bg: 'gray.100' }}>
              <LuX size={18} />
            </Box>
          </Flex>

          <Box px={6} py={4}>
            <VStack align="stretch" gap={3}>
              <Field label={t('origen.componentes.detail.code')} value={dm?.uniqueCode} />
              <Field label={t('origen.componentes.detail.miner')} value={dm?.minerName} />
            </VStack>

            <Text mt={6} mb={2} fontSize="sm" fontWeight="700" color="gray.700">
              {t('origen.componentes.detail.components')}
            </Text>

            {dm && dm.components.length > 0 ? (
              <VStack align="stretch" gap={2}>
                {dm.components.map((c) => {
                  const meta = getComponentMeta(c.componentTypeCode)
                  return (
                    <HStack key={c.id} gap={3} p={2} border="1px solid" borderColor="gray.200" borderRadius="md">
                      <Flex w="28px" h="28px" borderRadius="50%" bg={meta.color} alignItems="center" justifyContent="center" flexShrink={0}>
                        {meta.icon}
                      </Flex>
                      <VStack align="start" gap={0} flex="1">
                        <Text fontSize="sm" fontWeight="600">{c.componentTypeName}</Text>
                        {c.name && <Text fontSize="xs" color="gray.600">{c.name}</Text>}
                      </VStack>
                    </HStack>
                  )
                })}
              </VStack>
            ) : (
              <Text fontSize="sm" color="gray.500">{t('origen.componentes.noComponents')}</Text>
            )}
          </Box>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  )
}

function Field({ label, value }: { label: string; value?: string }) {
  return (
    <Box>
      <Text fontSize="xs" color="gray.500" fontWeight="600" textTransform="uppercase">{label}</Text>
      <Text fontSize="sm" color="gray.900">{value || '—'}</Text>
    </Box>
  )
}
